var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[(_vm.done)?_c('h1',[_vm._v(" You can close this window. Bye! ")]):_vm._e(),_c('div',{ref:"logoutIframe"})])}
var staticRenderFns = []

export { render, staticRenderFns }